import { getPayType } from '../../utils/index'

/**
 * 枢纽站模式暂不支持一键叫车
 */
export function startOrder(
  { baseLineId, onStopId, onStopName, offStopId, offStopName, singalNum = 1 },
  context
) {
  const areas = context.$store.state.run.areas || []
  const currentArea = areas.find(item => item.id === baseLineId)
  if (!currentArea) return Promise.reject({msg: '系统异常'})

  return context.$HomeService.fetchPrice({
    baseLineId,
    onStopId,
    onStopName,
    offStopId,
    offStopName,
    ticketNum: singalNum,
    userId: context.$UserService.getUserId(),
    payType: getPayType().id,
  }, context).then((res) => {
    const { originPrice, actualPrice } = res || {}
    const params = {
      baseLineId,
      offStopId,
      offStopName,
      onStopId,
      onStopName,
      payType: getPayType().id,
      singalNum, //  乘客数量
      ticketPrice: originPrice, // 原价
      sessionId: context.$UserService.getSessionId(),
      mobile: context.$UserService.getUserMobile(),
      actualPrice
    }
    console.log('params1111', params)
    return context.$AppService.order(params)
  })
}

let toast
export function showToast(text, visible, context) {
  if (!toast) {
    toast = context.$createToast({
      type: 'loading',
      text
    })
  }
  if (visible) {
    toast.show()
  } else {
    toast.hide()
  }
}
